import React from 'react';
import ReadOnlyBadge from './ReadOnlyBadge';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /**
   * Optional className for styling
   */
  className?: string;
  /**
   * Whether the textarea is read-only
   */
  readOnly?: boolean;
  /**
   * Whether to show a read-only badge on the component
   */
  showReadOnlyBadge?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', readOnly = false, showReadOnlyBadge = false, ...props }, ref) => {
    return (
      <div className="relative">
        <textarea
          ref={ref}
          className={`form-input ${readOnly ? 'form-input-readonly' : ''} ${className}`.trim()}
          readOnly={readOnly}
          {...props}
        />
        {readOnly && showReadOnlyBadge && <ReadOnlyBadge />}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;
